import { buildPartPeriodValidityFilter } from '#features/NationalCodes/buildCodePartPeriodValidityFilter'
import { buildCodeStatusFilter } from '#features/NationalCodes/buildCodeStatusFilter'
import type { FilterFunctions } from '#features/NationalCodes/filterNationalCodesTree'
import type { PartPeriod } from '#utils/DateString'

export const buildNationalCodesFilter = (partPeriod: PartPeriod | undefined): FilterFunctions => {
  const statusFilter = buildCodeStatusFilter('published')
  const partPeriodFilter = buildPartPeriodValidityFilter(partPeriod, partPeriod)

  return {
    codes: (code) => {
      return !(!statusFilter(code) || !partPeriodFilter(code))
    },
    includeEmpty: false,
  }
}
